import { EquityFieldKey } from 'types';

export const OPTIONS_CALCULATOR_ALL_FIELDS = [
  EquityFieldKey.prevClose,
  EquityFieldKey.earningsDate,
  EquityFieldKey.wkHigh52,
  EquityFieldKey.wkLow52,
  EquityFieldKey.callsum,
  EquityFieldKey.putsum,
  EquityFieldKey.putCallRatio,
  EquityFieldKey.nextExpGamma,
  EquityFieldKey.nextExpDelta,
  EquityFieldKey.topGammaExp,
  EquityFieldKey.topDeltaExp,
  EquityFieldKey.callGamma,
  EquityFieldKey.putGamma,
  EquityFieldKey.gammaRatio,
  EquityFieldKey.callDelta,
  EquityFieldKey.putDelta,
  EquityFieldKey.putVolume,
  EquityFieldKey.callVolume,
  EquityFieldKey.deltaRatio,
  EquityFieldKey.neSkew,
  EquityFieldKey.skew,
  EquityFieldKey.stock_volume,
  EquityFieldKey.rv30,
  EquityFieldKey.iv30,
  EquityFieldKey.skewRank,
  EquityFieldKey.garchRank,
  EquityFieldKey.ivRank,
  EquityFieldKey.iv_pct,
  EquityFieldKey.cskew_pct,
  EquityFieldKey.pskew_pct,
];
